import { Spinner } from '@styled-icons/evil';
import styled, { keyframes } from 'styled-components';

import createStyledIcon from './createStyledIcon';

const animationFrames = keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export default styled(createStyledIcon(Spinner))`
  animation: ${animationFrames};
  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
`;
